export const filterOptions = (options, { inputValue }) => {
    // split the input value into words, ignoring case, punctuation, diacritics, and whitespace
    const inputWords = inputValue
        .split(/\W/)
        .filter((word) => word.length > 0)
        .map((word) => normalizeForSearch(word));
    return options.filter((option) => {
        const primaryText = normalizeForSearch(option.primaryText);
        const secondaryText = option.secondaryText && normalizeForSearch(option.secondaryText);
        const code = option.code && normalizeForSearch(option.code);
        const result = inputWords.every((inputWord) => primaryText.includes(inputWord)) ||
            inputWords.every((inputWord) => secondaryText?.includes(inputWord)) ||
            inputWords.every((inputWord) => code?.includes(inputWord));
        return result;
    });
};
function normalizeForSearch(input) {
    return input
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
}
